<template>
  <div class="flex items-start justify-between gap-3 py-1">
    <span class="text-xs text-dashboard-muted flex-shrink-0 pt-0.5">{{ label }}</span>
    <div class="text-sm text-dashboard-text text-right min-w-0 max-w-[70%]">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{ label: string }>()
</script>
